// Mock data for Anadear Estates clone
// NOTE: This data is MOCKED for the frontend preview. It will be replaced by real backend API data.

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1653231905678-1371a378f3f3",
  exteriors: [
    "https://images.unsplash.com/photo-1595320078268-43862afaa9a5",
    "https://images.unsplash.com/photo-1550647512-8b8a24d4f646",
    "https://images.unsplash.com/photo-1732721176814-c0bc82db3971",
    "https://images.unsplash.com/photo-1740596261028-29a7ad308157",
    "https://images.unsplash.com/photo-1589806363334-42ca16a11a8a",
    "https://images.unsplash.com/photo-1706606992658-b7225196f1af",
    "https://images.unsplash.com/photo-1740596400206-f894025300b5",
  ],
  interiors: [
    "https://images.unsplash.com/photo-1598928506311-c55ded91a20c",
    "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg",
    "https://images.pexels.com/photos/18285958/pexels-photo-18285958.jpeg",
    "https://images.unsplash.com/photo-1556911220-bff31c812dba",
    "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4",
    "https://images.pexels.com/photos/7045356/pexels-photo-7045356.jpeg",
    "https://images.unsplash.com/photo-1616594039964-ae9021a400a0",
    "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8",
  ],
  about: "https://images.unsplash.com/photo-1589806363334-42ca16a11a8a",
};

export const COMPANY = {
  name: "Anadear Estates",
  email: "Enquiries@anadearestates.com",
  phone: "+44 7754 915190",
  phoneHref: "tel:+447754915190",
  whatsapp: "https://wa.me/447557735570",
  instagram: "https://www.instagram.com/anadearestates/",
  linkedin: "https://www.linkedin.com/company/anadear-estates-ltd/",
  areas: "Bath & Bristol",
  // ---- Regulatory / compliance (placeholders — update with your real details) ----
  legalName: "Anadear Estates Ltd",
  companyNumber: "15527498",
  vatNumber: "Not VAT registered",
  registeredAddress: "Parkhill Studio, Walton Road, Wetherby, LS23 6PD, United Kingdom",
  icoNumber: "ZB695452",
  redressScheme: "Property Redress Scheme (PRS)",
  cmpScheme: "UKALA Client Money Protection",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Buying", path: "/buying" },
  { label: "Lettings", path: "/lettings" },
  { label: "Area Guides", path: "/area-guides" },
  { label: "Weekly Blog", path: "/blog" },
  {
    label: "Our Services",
    path: "/services",
    children: [
      { label: "Selling", path: "/services#selling" },
      { label: "Lettings & Management", path: "/services#lettings" },
      { label: "Property Valuation", path: "/services#valuation" },
      { label: "Investment", path: "/services#investment" },
    ],
  },
  {
    label: "More",
    children: [
      { label: "The App", path: "/app" },
      { label: "Developments", path: "/developments" },
      { label: "About Us", path: "/about-us" },
    ],
  },
];

export const PROPERTIES = [
  {
    id: "1",
    slug: "duke-street-bath-ba2",
    title: "Duke Street, Bath, BA2",
    address: "Duke Street, Bath",
    postcode: "BA2",
    price: 335000,
    priceQualifier: "Offers in Region of",
    status: "for-sale",
    type: "Terraced House",
    bedrooms: 3,
    bathrooms: 1,
    receptions: 2,
    featured: true,
    images: [
      "https://images.unsplash.com/photo-1595320078268-43862afaa9a5",
      "https://images.unsplash.com/photo-1598928506311-c55ded91a20c",
      "https://images.unsplash.com/photo-1556911220-bff31c812dba",
      "https://images.unsplash.com/photo-1616594039964-ae9021a400a0",
    ],
    summary:
      "A beautifully presented three-bedroom Georgian terraced home in the heart of Bath, moments from the city centre.",
    description:
      "Situated on the sought-after Duke Street, this elegant Grade II listed Georgian townhouse offers characterful accommodation arranged over three floors. The property retains a wealth of period features including sash windows, high ceilings and original fireplaces, whilst benefitting from a tastefully modernised kitchen and bathroom. An ideal home for those seeking city-centre living with charm and convenience.",
    features: [
      "Grade II Listed Georgian Townhouse",
      "Three Double Bedrooms",
      "Period Features Throughout",
      "Modern Fitted Kitchen",
      "City Centre Location",
      "Courtyard Garden",
    ],
  },
  {
    id: "2",
    slug: "rowcroft-stroud-gl5",
    title: "Rowcroft, Stroud, GL5",
    address: "Rowcroft, Stroud",
    postcode: "GL5",
    price: 750000,
    priceQualifier: "Offers in Region of",
    status: "for-sale",
    type: "Detached House",
    bedrooms: 7,
    bathrooms: 7,
    receptions: 3,
    featured: true,
    images: [
      "https://images.unsplash.com/photo-1740596400206-f894025300b5",
      "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg",
      "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4",
      "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8",
    ],
    summary:
      "An imposing seven-bedroom period residence with generous grounds and far-reaching countryside views.",
    description:
      "A rare opportunity to acquire a substantial and versatile family home set within beautiful mature grounds on the edge of Stroud. Boasting seven bedrooms, seven bathrooms and three elegant reception rooms, the property is perfectly suited to multi-generational living or those seeking a home with income potential. Sympathetically maintained throughout, with an abundance of original features complemented by considered modern updates.",
    features: [
      "Seven Bedroom Detached Residence",
      "Three Elegant Reception Rooms",
      "Mature Landscaped Gardens",
      "Countryside Views",
      "Off-Street Parking for Several Vehicles",
      "Versatile Family Accommodation",
    ],
  },
  {
    id: "3",
    slug: "royal-crescent-bath-ba1",
    title: "Royal Crescent, Bath, BA1",
    address: "Royal Crescent, Bath",
    postcode: "BA1",
    price: 1250000,
    priceQualifier: "Guide Price",
    status: "for-sale",
    type: "Apartment",
    bedrooms: 2,
    bathrooms: 2,
    receptions: 1,
    featured: true,
    images: [
      "https://images.unsplash.com/photo-1653231905678-1371a378f3f3",
      "https://images.pexels.com/photos/18285958/pexels-photo-18285958.jpeg",
      "https://images.unsplash.com/photo-1616594039964-ae9021a400a0",
    ],
    summary:
      "A stunning two-bedroom apartment within Bath's world-famous Royal Crescent.",
    description:
      "An exceptional opportunity to own a piece of architectural history. This elegant second-floor apartment forms part of the iconic Royal Crescent, one of the finest examples of Georgian architecture in the United Kingdom. Beautifully appointed with soaring ceilings, sash windows overlooking the sweeping lawns, and an interior that balances period grandeur with contemporary comfort.",
    features: [
      "Iconic Royal Crescent Address",
      "Two Double Bedrooms",
      "Grand Georgian Proportions",
      "Views Over the Crescent Lawns",
      "Residents' Gardens",
      "World Heritage Setting",
    ],
  },
  {
    id: "4",
    slug: "great-pulteney-street-bath-ba2",
    title: "Great Pulteney Street, Bath, BA2",
    address: "Great Pulteney Street, Bath",
    postcode: "BA2",
    price: 2800,
    priceQualifier: "Per Calendar Month",
    status: "to-rent",
    type: "Apartment",
    bedrooms: 2,
    bathrooms: 2,
    receptions: 1,
    featured: true,
    images: [
      "https://images.unsplash.com/photo-1550647512-8b8a24d4f646",
      "https://images.unsplash.com/photo-1556911220-bff31c812dba",
      "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8",
    ],
    summary:
      "A luxurious two-bedroom apartment on Bath's most prestigious boulevard, available furnished.",
    description:
      "Positioned on the magnificent Great Pulteney Street, this beautifully refurbished apartment offers premium rental accommodation in one of Bath's most desirable locations. Featuring two generous double bedrooms, a stylish open-plan living space and a high specification kitchen, the property is available furnished to an exacting standard. Early viewing is highly recommended.",
    features: [
      "Prestigious Great Pulteney Street",
      "Two Double Bedrooms",
      "Available Furnished",
      "High Specification Kitchen",
      "Walking Distance to City Centre",
      "Available Immediately",
    ],
  },
  {
    id: "5",
    slug: "widcombe-hill-bath-ba2",
    title: "Widcombe Hill, Bath, BA2",
    address: "Widcombe Hill, Bath",
    postcode: "BA2",
    price: 1950,
    priceQualifier: "Per Calendar Month",
    status: "to-rent",
    type: "Semi-Detached House",
    bedrooms: 3,
    bathrooms: 2,
    receptions: 2,
    featured: false,
    images: [
      "https://images.unsplash.com/photo-1732721176814-c0bc82db3971",
      "https://images.pexels.com/photos/7045356/pexels-photo-7045356.jpeg",
      "https://images.pexels.com/photos/20418771/pexels-photo-20418771.jpeg",
    ],
    summary:
      "A charming three-bedroom family home in the popular Widcombe area, with garden and parking.",
    description:
      "A well-proportioned three-bedroom semi-detached home set in the highly regarded Widcombe area of Bath. The property offers comfortable family accommodation with two reception rooms, a private rear garden and off-street parking. Ideally located for local schools, independent shops and excellent transport links into the city centre.",
    features: [
      "Three Bedroom Family Home",
      "Private Rear Garden",
      "Off-Street Parking",
      "Two Reception Rooms",
      "Popular Widcombe Location",
      "Close to Local Schools",
    ],
  },
  {
    id: "6",
    slug: "clifton-village-bristol-bs8",
    title: "Clifton Village, Bristol, BS8",
    address: "Clifton Village, Bristol",
    postcode: "BS8",
    price: 895000,
    priceQualifier: "Guide Price",
    status: "for-sale",
    type: "Town House",
    bedrooms: 4,
    bathrooms: 3,
    receptions: 2,
    featured: false,
    images: [
      "https://images.unsplash.com/photo-1740596261028-29a7ad308157",
      "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4",
      "https://images.unsplash.com/photo-1598928506311-c55ded91a20c",
    ],
    summary:
      "A handsome four-bedroom townhouse in the heart of fashionable Clifton Village.",
    description:
      "This elegant Victorian townhouse sits within the vibrant heart of Clifton Village, surrounded by boutique shops, cafés and the celebrated Clifton Suspension Bridge. Arranged over four floors, the home offers spacious and flexible living with four bedrooms, three bathrooms and beautifully proportioned reception rooms. A rare and characterful home in one of Bristol's most sought-after neighbourhoods.",
    features: [
      "Four Bedroom Victorian Townhouse",
      "Heart of Clifton Village",
      "Period Features Retained",
      "Two Reception Rooms",
      "Courtyard Garden",
      "Highly Desirable Location",
    ],
  },
  {
    id: "7",
    slug: "lansdown-road-bath-ba1",
    title: "Lansdown Road, Bath, BA1",
    address: "Lansdown Road, Bath",
    postcode: "BA1",
    price: 525000,
    priceQualifier: "Offers in Region of",
    status: "for-sale",
    type: "Apartment",
    bedrooms: 2,
    bathrooms: 1,
    receptions: 1,
    featured: false,
    images: [
      "https://images.unsplash.com/photo-1706606992658-b7225196f1af",
      "https://images.pexels.com/photos/18285958/pexels-photo-18285958.jpeg",
      "https://images.unsplash.com/photo-1616594039964-ae9021a400a0",
    ],
    summary:
      "A bright and spacious two-bedroom apartment with elevated views towards the city.",
    description:
      "Occupying an enviable position on Lansdown Road, this generously sized apartment enjoys wonderful elevated views across the city of Bath. The accommodation comprises two double bedrooms, a light-filled reception room and a well-appointed kitchen. With allocated parking and communal gardens, this is an ideal home for professionals or downsizers alike.",
    features: [
      "Two Double Bedrooms",
      "Elevated City Views",
      "Allocated Parking",
      "Communal Gardens",
      "Light-Filled Reception Room",
      "Sought-After Lansdown",
    ],
  },
  {
    id: "8",
    slug: "bedminster-bristol-bs3",
    title: "Bedminster, Bristol, BS3",
    address: "Bedminster, Bristol",
    postcode: "BS3",
    price: 1450,
    priceQualifier: "Per Calendar Month",
    status: "to-rent",
    type: "Terraced House",
    bedrooms: 2,
    bathrooms: 1,
    receptions: 1,
    featured: false,
    images: [
      "https://images.unsplash.com/photo-1595320078268-43862afaa9a5",
      "https://images.unsplash.com/photo-1556911220-bff31c812dba",
      "https://images.pexels.com/photos/7045356/pexels-photo-7045356.jpeg",
    ],
    summary:
      "A stylish two-bedroom terraced home in the creative and vibrant Bedminster area.",
    description:
      "Located in the ever-popular Bedminster, renowned for its independent spirit and famous street art, this well-presented two-bedroom terraced home makes an excellent rental proposition. The property features a modern kitchen, a comfortable living room and a low-maintenance rear courtyard, all within easy reach of North Street's celebrated bars, cafés and shops.",
    features: [
      "Two Bedroom Terraced Home",
      "Modern Fitted Kitchen",
      "Rear Courtyard",
      "Vibrant Bedminster Location",
      "Close to North Street",
      "Excellent Transport Links",
    ],
  },
];

export const TESTIMONIALS = [
  {
    id: "t1",
    name: "David Aspin",
    role: "",
    quote:
      "I've watched William build Anadear Estates with genuine passion, professionalism, and a clear commitment to doing things the right way. He brings a level of care and attention to every client and property that truly sets him apart. Whether it's sales, lettings, or investment, William approaches every instruction with integrity and a determination to deliver the very best outcome.",
  },
  {
    id: "t2",
    name: "Anonymous Landlord",
    role: "",
    quote:
      "I have had the pleasure of working with Anadear Estates, led by William Aspin, for the management of my rental properties, and I cannot recommend them highly enough. As a landlord, it's crucial to have a reliable, professional team to handle all aspects of property management, and Anadear Estates has consistently exceeded my expectations at every turn.",
  },
  {
    id: "t3",
    name: "Anonymous Home Seller",
    role: "",
    quote:
      "Anadear Estates were fabulous from start to finish and in comparison to your typical high street agent, they were personable and got me the highest amount back.",
  },
];

export const SERVICES = [
  {
    id: "selling",
    title: "Selling Your Home",
    tagline: "Achieving the best possible price, seamlessly.",
    description:
      "From accurate valuation and professional photography to strategic marketing and expert negotiation, we manage every stage of your sale with care. Our proactive approach and local expertise ensure your property reaches the right buyers and achieves the best possible result.",
    points: [
      "Accurate, honest valuations",
      "Professional photography & floorplans",
      "Premium listing on Rightmove & Zoopla",
      "Expert negotiation & sales progression",
    ],
  },
  {
    id: "lettings",
    title: "Lettings & Management",
    tagline: "Peace of mind for landlords and tenants alike.",
    description:
      "Whether you require a fully managed service or tenant-find only, our lettings team delivers a professional, compliant and stress-free experience. We handle everything from marketing and referencing to inventories, maintenance and rent collection.",
    points: [
      "Fully managed & tenant-find services",
      "Comprehensive tenant referencing",
      "Full legal compliance & inventories",
      "Responsive maintenance coordination",
    ],
  },
  {
    id: "valuation",
    title: "Property Valuation",
    tagline: "Know your property's true worth.",
    description:
      "Understanding the value of your property is the first step in any move. Our free, no-obligation valuations combine local market knowledge with the latest data to give you a clear, realistic figure — whether you're selling, letting or simply curious.",
    points: [
      "Free, no-obligation valuations",
      "Instant online valuation reports",
      "Local market insights & trends",
      "Guidance on maximising value",
    ],
  },
  {
    id: "investment",
    title: "Property Investment",
    tagline: "Building portfolios across Bath & Bristol.",
    description:
      "For investors, we offer strategic advice grounded in genuine local knowledge. From identifying opportunities and assessing yields to sourcing, managing and growing your portfolio, we act as a trusted partner in your investment journey.",
    points: [
      "Investment opportunity sourcing",
      "Yield & return analysis",
      "Portfolio management",
      "Long-term strategic advice",
    ],
  },
];

export const BLOG_POSTS = [
  {
    id: "b1",
    slug: "bath-property-market-outlook",
    title: "Bath Property Market Outlook: What to Expect This Year",
    excerpt:
      "Our take on where the Bath and Bristol property market is heading, and what it means for buyers, sellers and landlords.",
    date: "2026-01-12",
    category: "Market Insights",
    image: "https://images.unsplash.com/photo-1589806363334-42ca16a11a8a",
    readTime: "5 min read",
  },
  {
    id: "b2",
    slug: "preparing-your-home-for-sale",
    title: "Ten Simple Ways to Prepare Your Home for Sale",
    excerpt:
      "First impressions count. Here are our tried-and-tested tips for presenting your property at its very best.",
    date: "2026-01-05",
    category: "Selling",
    image: "https://images.unsplash.com/photo-1598928506311-c55ded91a20c",
    readTime: "4 min read",
  },
  {
    id: "b3",
    slug: "landlord-guide-to-compliance",
    title: "A Landlord's Guide to Staying Compliant in 2026",
    excerpt:
      "The rules for landlords are always evolving. We break down the essentials to keep your lettings fully compliant.",
    date: "2025-12-18",
    category: "Lettings",
    image: "https://images.unsplash.com/photo-1550647512-8b8a24d4f646",
    readTime: "6 min read",
  },
  {
    id: "b4",
    slug: "why-clifton-remains-a-buyer-favourite",
    title: "Why Clifton Village Remains a Buyer Favourite",
    excerpt:
      "A closer look at one of Bristol's most beloved neighbourhoods and why demand shows no sign of slowing.",
    date: "2025-12-08",
    category: "Area Guides",
    image: "https://images.unsplash.com/photo-1740596261028-29a7ad308157",
    readTime: "5 min read",
  },
];

export const TRUST_LOGOS = [
  { name: "Street Certified", label: "STREET CERTIFIED" },
  { name: "The Market", label: "the MARKET" },
  { name: "Zoopla", label: "Zoopla" },
  { name: "PRS", label: "PRS" },
  { name: "TDS", label: "TDS" },
  { name: "UKALA", label: "UKALA" },
];
